export default function ConvertDate(date, options) {
  let publicationDate = new Date(date);
  // let today = Date.now();
  // let diff_ms = today - publicationDate;
  // let options = { year: 'numeric', month: 'long', day: 'numeric' };
  // let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return publicationDate.toLocaleDateString("en-US", options);
};